module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Site Number Requests")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "row row-wider"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.type === 'search') ? _c('form', {
    staticClass: "form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loadData($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.siteName),
      expression: "searchDto.siteName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "SearchSiteName"
    },
    domProps: {
      "value": (_vm.searchDto.siteName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "siteName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.fieldOrgNumber),
      expression: "searchDto.fieldOrgNumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchFieldOrgNumber"
    },
    domProps: {
      "value": (_vm.searchDto.fieldOrgNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "fieldOrgNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.projectName),
      expression: "searchDto.projectName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "searchProjectName"
    },
    domProps: {
      "value": (_vm.searchDto.projectName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.searchDto, "projectName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchDto.workflowStatusId),
      expression: "searchDto.workflowStatusId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "searchStatus"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.searchDto, "workflowStatusId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Workflow Status")]), _vm._v(" "), _vm._l((_vm.workflowList), function(status) {
    return _c('option', {
      key: status.workflowStatusId,
      domProps: {
        "value": status.workflowStatusId
      }
    }, [_vm._v(_vm._s(status.description))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    },
    on: {
      "click": _vm.loadData
    }
  }, [_vm._v("Search")])])])]) : _vm._e(), _vm._v(" "), (_vm.type === 'search') ? _c('div', {
    staticClass: "pull-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "to": "/SiteNumberRequest",
      "tag": "button"
    }
  }, [_vm._v("Add Off-inventory Site Number Request")])], 1) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e(), _vm._v(" "), _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.gridSpec.tableData,
      "columns": _vm.gridSpec.columns,
      "options": _vm.gridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "16px"
          },
          attrs: {
            "to": {
              path: '/SiteNumberRequest/' + props.row.siteNumberRequestId
            },
            "tag": "a"
          }
        })], 1)]
      }
    }])
  })], 1)], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2"
  }, [_c('label', {
    attrs: {
      "for": "SearchSiteName"
    }
  }, [_vm._v("Name/Identifier")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-sm-offset-1"
  }, [_c('label', {
    attrs: {
      "for": "searchFieldOrgNumber"
    }
  }, [_vm._v("Field Org. Number")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', {
    attrs: {
      "for": "searchProjectName"
    }
  }, [_vm._v("Project Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-2 col-sm-offset-1"
  }, [_c('label', {
    attrs: {
      "for": "searchStatus"
    }
  }, [_vm._v("Status")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6270a412"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SiteNumberRequests.vue
// module id = 948
// module chunks = 1